export const ON_SELECTED_PAGE_CHANGED = "ON_SELECTED_PAGE_CHANGED";
export const ON_APP_CONFIGURE = "ON_APP_CONFIGURE";
export const ON_USER_DATA_LOAD = "ON_USER_DATA_LOAD";
export const ON_AZURE_USER_LOAD = "ON_AZURE_USER_LOAD";
export const ON_IFS_USER_LOAD = "ON_IFS_USER_LOAD";
export const ON_SEARCH_BACKEND = "ON_SEARCH_BACKEND";
export const ON_SEARCH_LATEST_IFS_DOC = "ON_SEARCH_LATEST_IFS_DOC";
export const ON_SEARCH = "ON_SEARCH";
export const ON_FILE_TYPE_SELECTED = "ON_FILE_TYPE_SELECTED";
export const ON_SEARCHED_FILE_TYPE = "ON_SEARCHED_FILE_TYPE";
export const ON_ONEDRIVE_FILE_TYPE_SELECTED = "ON_ONEDRIVE_FILE_TYPE_SELECTED";
export const ON_NO_OF_RECORDS_CHANGED = "ON_NO_OF_RECORDS_CHANGED";
export const ON_IFS_DOCUMENTS_SELECTED = "ON_IFS_DOCUMENTS_SELECTED";
export const ONEDRIVE_SEARCH = "ONEDRIVE_SEARCH";
export const ON_ONEDRIVE_SEARCH_BACKEND = "ON_ONEDRIVE_SEARCH_BACKEND";
export const ON_TEMPLATE_SEARCH = "ON_TEMPLATE_SEARCH";
export const ON_SET_SEARCH_INITIAL_STATE = "ON_SET_SEARCH_INITIAL_STATE";
export const ON_SEARCH_Filtered = "ON_SEARCH_Filtered";
export const ONEDRIVE_SEARCH_Filtered = "ONEDRIVE_SEARCH_Filtered";
export const ON_TEMPLATE_SEARCH_FILTERED = "ON_TEMPLATE_SEARCH_FILTERED";
export const GET_RECENT_DOCUMENT_BY_USER = "GET_RECENT_DOCUMENT_BY_USER";
export const ON_SET_DOCUMENT_INITIAL_STATE = "ON_SET_DOCUMENT_INITIAL_STATE";
export const ON_SEARCH_TEXT = "ON_SEARCH_TEXT";
export const ON_PAGE_SIZE_CHANGE = "ON_PAGE_SIZE_CHANGE";
export const ON_SEARCH_BY_CHANGE = "ON_SEARCH_BY_CHANGE";
export const ON_DELETE_ONEDRIVE_DOCUMENT = "ON_DELETE_ONEDRIVE_DOCUMENT";
export const ON_ALLOW_SELECTION = "ON_ALLOW_SELECTION";
export const ON_PROCESS_SUCCESS = "ON_PROCESS_SUCCESS";
export const ON_COPY_LINK_CLICK = "ON_COPY_LINK_CLICK";
export const ON_SHARE_LINK_CLICK = "ON_SHARE_LINK_CLICK";
export const ON_CHECK_IN_SUCCESS = "ON_CHECK_IN_SUCCESS";
export const ON_SHARE_DOCUMENT_CLICK = "ON_SHARE_DOCUMENT_CLICK";
export const ON_UPLOAD_CLICK = "ON_UPLOAD_CLICK";
export const ON_REDIRECT_LINKS = "ON_REDIRECT_LINKS";
export const ON_DELETE_SUCCESS = "ON_DELETE_SUCCESS";

export const ON_ROW_SELECTION_CHANGE = "ON_ROW_SELECTION_CHANGE";
export const ON_MULTIPLE_ROW_SELECTED = "ON_MULTIPLE_ROW_SELECTED";
export const ON_ONE_WORD_SELECTED = "ON_ONE_WORD_SELECTE";
export const ON_ONE_PDF_SELECTED = "ON_ONE_PDF_SELECTED";
export const ON_SEARCH_VALUE_CHANGE = "ON_SEARCH_VALUE_CHANGE";
export const ON_CONTEXTUAL_MENU_DETAILS_CLICK =
    "ON_CONTEXTUAL_MENU_DETAILS_CLICK";
export const ON_CONTEXTUAL_MENU_COPY_LINK_CLICK =
    "ON_CONTEXTUAL_MENU_COPY_LINK_CLICK";
export const ON_CONTEXTUAL_MENU_SHARE_LINK_CLICK =
    "ON_CONTEXTUAL_MENU_SHARE_LINK_CLICK";
export const ON_CONTEXTUAL_MENU_SHARE_DOCUMENT_CLICK =
    "ON_CONTEXTUAL_MENU_SHARE_DOCUMENT_CLICK";
export const ON_CLOSE_MORE_DETAILS_MODAL_CLICK =
    "ON_CLOSE_MORE_DETAILS_MODAL_CLICK";
export const ON_CONTEXTUAL_MENU_TEMPLATE_DETAILS_CLICK =
    "ON_CONTEXTUAL_MENU_TEMPLATE_DETAILS_CLICK";

export const ON_CLOSE_TEMPLATE_MORE_DETAILS_MODAL_CLICK =
    "ON_CLOSE_TEMPLATE_MORE_DETAILS_MODAL_CLICK";

export const ON_SEARCH_RESULT_COUNT_CHANGE = "ON_SEARCH_RESULT_COUNT_CHANGE";
export const ON_IFS_SEARCH_RESULT_COUNT_CHANGE = "ON_IFS_SEARCH_RESULT_COUNT_CHANGE";
export const ON_ONEDRIVE_SEARCH_RESULT_COUNT_CHANGE =
    "ON_ONEDRIVE_SEARCH_RESULT_COUNT_CHANGE";
export const ON_PAGE_CHANGE = "ON_PAGE_CHANGE";
export const ON_SELECTED_PAGE_INDEX_CHANGE = "ON_SELECTED_PAGE_INDEX_CHANGE";
export const ON_SELECTED_ONEDRIVE_PAGE_INDEX_CHANGE =
    "ON_SELECTED_ONEDRIVE_PAGE_INDEX_CHANGE";
export const SET_INITIAL_ROW_SELECTION_DETAILS =
    "SET_INITIAL_ROW_SELECTION_DETAILS";
export const SET_INITIAL_VALUE = "SET_INITIAL_VALUE";

export const ON_SEARCH_CLICK = "ON_SEARCH_CLICK";
export const ON_SEARCH_TYPE_CHANGE = "ON_SEARCH_TYPE_CHANGE";
export const ON_RELEASE_LEVEL_CHANGE = "ON_RELEASE_LEVEL_CHANGE";
export const ON_ADVANCE_SEARCH_START_DATE_CHANGE =
    "ON_ADVANCE_SEARCH_START_DATE_CHANGE";
export const ON_ADVANCE_SEARCH_END_DATE_CHANGE =
    "ON_ADVANCE_SEARCH_END_DATE_CHANGE";
export const ON_ANY_DATE_CHECKED = "ON_ANY_DATE_CHECKED";
export const ON_ONLY_WHERE_USER_CHECKED = "ON_ONLY_WHERE_USER_CHECKED";
export const ON_CHECKED_OUT_TO_ME = "FALSE";
export const ON_PLATFORM_OPEN_LINK_CHANGE = "ON_PLATFORM_OPEN_LINK_CHANGE";
export const ON_ACTIVE_PAGE_CHANGE = "ON_ACTIVE_PAGE_CHANGE";
export const ON_COPYLINK_TOGGLE_CHANGE = "ON_COPYLINK_TOGGLE_CHANGE";
export const ON_COPYLINK_TOGGLE_CHANGE_DOWNLOADVIEW =
    "ON_COPYLINK_TOGGLE_CHANGE_DOWNLOADVIEW";
export const ON_DOWNLOAD_CLICK = "ON_DOWNLOAD_CLICK";
export const ON_DOCUMENT_DOWNLOAD = "ON_DOCUMENT_DOWNLOAD";
export const ON_GENERATING_COPY_LINKS = "ON_GENERATING_COPY_LINKS";
export const ON_ONEDRIVE_SETTINGS_CHANGE = "ON_ONEDRIVE_SETTINGS_CHANGE";
export const ON_ONE_DRIVE_TOGGLE_ENABLE_DOWNLOAD_OR_NOT =
    "ON_ONE_DRIVE_TOGGLE_ENABLE_DOWNLOAD_OR_NOT";
export const ON_ONE_DRIVE_ALLOW_EDITING_CHECKED =
    "ON_ONE_DRIVE_ALLOW_EDITING_CHECKED";
export const ON_ONE_DRIVE_SETTING_CANCEL_CLICK =
    "ON_ONE_DRIVE_SETTING_CANCEL_CLICK";
export const POPUP_LINK_SETTING_MODAL = "POPUP_LINK_SETTING_MODAL";
export const ON_ONEDRIVE_TOGGLE_OPEN_IN_REVIEW_MODE_ONLY =
    "ON_ONEDRIVE_TOGGLE_OPEN_IN_REVIEW_MODE_ONLY";
export const ON_VIWE_DOCUMENT_WEB = "ON_VIWE_DOCUMENT_WEB";
export const POPUP_DOWNLOAD_VIEW_MODAL = "POPUP_DOWNLOAD_VIEW_MODAL";
export const ON_DOWNLOAD_VIEWTOGGLE_CHANGE = "ON_DOWNLOAD_VIEWTOGGLE_CHANGE";
export const ON_POPUP_DOWNLOAD_VIEW_APPLY = "ON_POPUP_DOWNLOAD_VIEW_APPLY";

export const ON_ADVANCE_SEARCH_DOC_CLASS_CHANGE =
    "ON_ADVANCE_SEARCH_DOC_CLASS_CHANGE";
export const ON_ADVANCE_SEARCH_FORMAT_CHANGE =
    "ON_ADVANCE_SEARCH_FORMAT_CHANGE";
export const ON_DIALOG_MENU_OK_BUTTON_CLICK = "ON_DIALOG_MENU_OK_BUTTON_CLICK";
export const ON_SUCCESS_DIALOG_MENU_OK_BUTTON_CLICK =
    "ON_SUCCESS_DIALOG_MENU_OK_BUTTON_CLICK";
export const ON_MESSAGE_BOX_OK_BUTTON_CLICK = "ON_MESSAGE_BOX_OK_BUTTON_CLICK";
export const ON_WRONG_FILE_FORMAT = "ON_WRONG_FILE_FORMAT";
export const ON_MESSAGE_BOX_OPEN = "ON_MESSAGE_BOX_OPEN";
export const ON_MESSAGE_BOX_INVOKE = "ON_MESSAGE_BOX_INVOKE";
export const ON_WRONG_FILE_FORMAT_TYPE = "ON_WRONG_FILE_FORMAT_TYPE";

export const ON_SET_VERSION_DETAILS = "ON_SET_VERSION_DETAILS";
export const ON_SET_IFS_ENV_DETAILS = "ON_SET_IFS_ENV_DETAILS";

export const ON_ONEDRIVE_OPTIONS_DATE_CHANGE =
    "ON_ONEDRIVE_OPTIONS_DATE_CHANGE";
export const ON_ONE_DRIVE_SETTING_APPLY_CLICK =
    "ON_ONE_DRIVE_SETTING_APPLY_CLICK";
export const ON_ONEDRIVE_OPTIONS__PASSWORD_CHANGE =
    "ON_ONEDRIVE_OPTIONS__PASSWORD_CHANGE";
export const ON_ONEDRIVE_OPTIONS__PEOPLE_SELECTED =
    "ON_ONEDRIVE_OPTIONS__PEOPLE_SELECTED";

export const PEOPLE_PICKER_CONTACTS = "PEOPLE_PICKER_CONTACTS";
export const ON_MAIN_COMP_WIDTH_CHANGE = "ON_MAIN_COMP_WIDTH_CHANGE";

export const DOCCLASS_FORMAT_VALUES_FILTERED =
    "DOCCLASS_FORMAT_VALUES_FILTERED";
export const VIEW_DOC_TYPE = "VIEW";
export const ORIGINAL_DOC_TYPE = "ORIGINAL";
export const ON_ONE_DRIVE_APPLY_BUTTON_DISABLE =
    "ON_ONE_DRIVE_APPLY_BUTTON_DISABLE";

export const ON_CHECKIN_NEW_STATUS_CHANGED = "ON_CHECKIN_NEW_STATUS_CHANGED";
export const ON_DOCTITLE_CHANGED = "ON_DOCTITLE_CHANGED";
export const ON_WHERE_CLAUSE_CHANGED = "ON_WHERE_CLAUSE_CHANGED";
export const ON_PIVOT_SELECTEDKEY_CHANGED = "ON_PIVOT_SELECTEDKEY_CHANGED";
export const ON_ADV_OBJ_CON_COLUMNS_CHANGED = "ON_ADV_OBJ_CON_COLUMNS_CHANGED";
export const ON_MRU_KEYNAMES_CHANGED = "ON_MRU_KEYNAMES_CHANGED";
export const ON_ADV_OBJ_CON_SEARCH_RESULT_CHANGED =
    "ON_ADV_OBJ_CON_SEARCH_RESULT_CHANGED";
export const ON_SELECTEDKEY_LUNAME_CHANGED = "ON_SELECTEDKEY_LUNAME_CHANGED";
export const ON_ATTACHEDDOCINFO_CHANGED = "ON_ATTACHEDDOCINFO_CHANGED";
export const ON_DOCCLASS_CHANGED = "ON_DOCCLASS_CHANGED";
export const ON_DOCFORMAT_CHANGED = "ON_DOCFORMAT_CHANGED";
export const ON_VIEWREQUIRED_CHANGED = "ON_VIEWREQUIRED_CHANGED";
export const ON_FORMATREQUIRED_CHANGED = "ON_FORMATREQUIRED_CHANGED";
export const ON_OBJCONREQUIRED_CHANGED = "ON_OBJCONREQUIRED_CHANGED";
export const ON_RESTRICTEDACCESS_CHANGED = "ON_RESTRICTEDACCESS_CHANGED";
export const ON_DOCDOCFORMAT_CHANGED = "ON_DOCDOCFORMAT_CHANGED";
export const ON_DOCDOCFORMATLIST_CHANGED = "ON_DOCDOCFORMATLIST_CHANGED";
export const ON_LOGICALUNITLIST_CHANGED = "ON_LOGICALUNITLIST_CHANGED";
export const ON_DOCRELEASE_CHANGED = "ON_DOCRELEASE_CHANGED";
export const ON_FILEUPLOAD_CHANGE = "ON_FILEUPLOAD_CHANGE";
export const ON_UPLOADEDFILE_COUNT_CHANGED = "ON_UPLOADEDFILE_COUNT_CHANGED";
export const ON_FILETYPES_CHANGED = "ON_FILETYPES_CHANGED";

export const ON_CHECKINTYPE_TAB_CHANGE = "ON_CHECKINTYPE_TAB_CHANGE";
export const ON_DOC_CHECKIN_TYPE = "ON_DOC_CHECKIN_TYPE";
export const ON_CHECKIN_DOC = "ON_CHECKIN_DOC";
export const ON_SPINNER_TEXT_CHANGE = "ON_SPINNER_TEXT_CHANGE";
export const ON_ATTACHED_DOC_INFO = "ON_ATTACHED_DOC_INFO";
export const ON_VIEWCOPY_DOC_INFO = "ON_VIEWCOPY_DOC_INFO";

export const ON_CREATE_VIEWCOPY_CHANGED = "ON_CREATE_VIEWCOPY_CHANGED";
export const ON_CREATE_VIEWCOPY_ENABLE_CHANGED =
    "ON_CREATE_VIEWCOPY_ENABLE_CHANGED";
/** User toggled "Automatically generate view copy" vs system-applied defaults. */
export const ON_VIEWCOPY_AUTOGENERATE_USER_ADJUSTED =
    "ON_VIEWCOPY_AUTOGENERATE_USER_ADJUSTED";
export const ON_VIEWCOPYUPLOAD_CHANGE = "ON_VIEWCOPYUPLOAD_CHANGE";
export const ON_UPLOADEDVIEWCOPY_COUNT_CHANGED =
    "ON_UPLOADEDVIEWCOPY_COUNT_CHANGED";

export const ON_RECENT_OBJECT_VALUES = "ON_RECENT_OBJECT_VALUES";
export const ON_ROW_SELECTION_CHANGE_RECENT_OBJECTS =
    "ON_ROW_SELECTION_CHANGE_RECENT_OBJECTS";
export const ON_RECENT_OBJECT_SELECTED = "ON_RECENT_OBJECT_SELECTED";
export const ON_RECENT_OBJECT_SELECTED_DESCRIPTION =
    "ON_RECENT_OBJECT_SELECTED_DESCRIPTION";
export const ON_ROW_SELECTION_CHANGE_SEARCH_OBJECTS =
    "ON_ROW_SELECTION_CHANGE_SEARCH_OBJECTS";
export const ON_ADV_OBJ_SELECTED = "ON_ADV_OBJ_SELECTED";
export const ON_ADV_OBJ_SELECT_COMPLETED = "ON_ADV_OBJ_SELECT_COMPLETED";

export const ON_SEARCH_LUNAME = "ON_SEARCH_LUNAME";
export const ON_SEARCH_OBJ_ID = "ON_SEARCH_OBJ_ID";
export const ON_SEARCH_KEY_REF = "ON_SEARCH_KEY_REF";

/***************Recent Objects Store **********************/
export const ON_RECENT_OBJECTS_CHANGED = "ON_RECENT_OBJECTS_CHANGED";
export const ON_RECENT_OBJECTS_DATA_LOAD_STATUS = "ON_RECENT_OBJECTS_DATA_LOAD_STATUS";
export const ON_RECENT_OBJECTS_DATA_ERROR_MESSAGE = "ON_RECENT_OBJECTS_DATA_ERROR_MESSAGE";
/***************Recent Objects Store **********************/

export const ON_CHECKOUT_STATUS = "ON_CHECKOUT_STATUS";

export const ON_REVISIONSEARCH_CLICK = "ON_REVISIONSEARCH_CLICK";
export const ON_REVISIONSEARCH_ITEM_SELECT = "ON_REVISIONSEARCH_ITEM_SELECT";
export const ON_SELECTED_OBJECTS_CHANGED = "ON_SELECTED_OBJECTS_CHANGED";
export const ON_NEWREVISION_CHANGED = "ON_NEWREVISION_CHANGED";
export const ON_NEWREVISION_CHANGED_WAR_MSG = "ON_NEWREVISION_CHANGED_WAR_MSG";
export const ON_NEWREVISION_TEXT_CHANGED = "ON_NEWREVISION_TEXT_CHANGED";
export const ON_NEWREVISION_OBJCON_CHANGED = "ON_NEWREVISION_OBJCON_CHANGED";
export const ON_NEWREVISION_INFO_CHANGED = "ON_NEWREVISION_INFO_CHANGED";
export const ON_NEWREVISION_DOC_INFO_CHANGED = "ON_NEWREVISION_DOC_INFO_CHANGED";
export const ON_NEWREVISION_INFO_APPLIED = "ON_NEWREVISION_INFO_APPLIED";
export const ON_FILE_DOWNLOAD = "ON_FILE_DOWNLOAD";
export const ON_VIEWCOPY_UPLOAD_FAILED = "ON_VIEWCOPY_UPLOAD_FAILED";
export const ON_NEWREVISION_DISABLED = "ON_NEWREVISION_DISABLED";
export const ON_ADV_OBJ_RESULTS_STATUS_CHANGED =
    "ON_ADV_OBJ_RESULTS_STATUS_CHANGED";
export const ON_ADV_OBJ_META_DATA_STATUS_CHANGED =
    "ON_ADV_OBJ_META_DATA_STATUS_CHANGED";
export const ON_DOCUMENT_UPLOAD_FAILED = "ON_DOCUMENT_UPLOAD_FAILED";
export const FETCH_COPYRIGHT = "FETCH_COPYRIGHT";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const ON_RESET_LANGUAGE = "ON_RESET_LANGUAGE";
export const CLICKED_ON_SAME_NAV_ITEM = "CLICKED_ON_SAME_NAV_ITEM";
export const GET_USER_INFO = "GET_USER_INFO";
export const GET_TOKEN_INFO = "GET_TOKEN_INFO";
export const GET_TEAMS_CONTEXT = "GET_TEAMS_CONTEXT";

export const ON_ONEDRIVE_DATALOAD = "ON_ONEDRIVE_DATALOAD";
export const ON_OBJECTCONNECTION_DATALOAD = "ON_OBJECTCONNECTION_DATALOAD";

export const ON_CHECKIN_DOCUMENT_PROGRESS = "ON_CHECKIN_DOCUMENT_PROGRESS";
export const ON_CHECKIN_PROGRESS_CHANGED = "ON_CHECKIN_PROGRESS_CHANGED";
export const ON_IFS_DOCUMENT_LOAD_CHANGED = "ON_IFS_DOCUMENT_LOAD_CHANGED";
export const ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED = "ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED";
export const ON_ONEDRIVE_DOCUMENT_BACKGROUND_LOAD_CHANGED = "ON_ONEDRIVE_DOCUMENT_BACKGROUND_LOAD_CHANGED";
export const ON_DOCUMENT_REVISION_LOAD_CHANGED =
    "ON_DOCUMENT_REVISION_LOAD_CHANGED";
export const ON_BASIC_DATA_INFO_CHANGED = "ON_BASIC_DATA_INFO_CHANGED";
export const ON_CHECK_IN_TO_IFS_CLICKED = "ON_CHECK_IN_TO_IFS_CLICKED";
export const ONEDRIVE_DOCUMENT_ID = "ONEDRIVE_DOCUMENT_ID";
export const ONEDRIVE_DOCUMENT_PREVIEW_URL = "ONEDRIVE_DOCUMENT_PREVIEW_URL";
export const ONEDRIVE_DOCUMENT_DOWNLOAD_URL = "ONEDRIVE_DOCUMENT_DOWNLOAD_URL";
export const ON_CLEAR_ONEDRIVE_DOCUMENT_DOWNLOAD_URL =
    "ON_CLEAR_ONEDRIVE_DOCUMENT_DOWNLOAD_URL";
export const ON_ONEDRIVE_URL_DOWNLOAD_STATUS =
    "ON_ONEDRIVE_URL_DOWNLOAD_STATUS";
export const ON_UPLOAD_ONEDRIVE_FILES = "ON_UPLOAD_ONEDRIVE_FILES";
export const ON_UPLOAD_ONEDRIVE_STATUS_CHANGED =
    "ON_UPLOAD_ONEDRIVE_STATUS_CHANGED";
export const ON_DISPLAY_DETAILS_BUTTON = "ON_DISPLAY_DETAILS_BUTTON";
export const ON_PAGINATION_LOAD = "ON_PAGINATION_LOAD"
export const ON_FILTER_VISIBILITY = "ON_FILTER_VISIBILITY"
export const ON_ONEDRIVE_FILTER_VISIBILITY = "ON_ONEDRIVE_FILTER_VISIBILITY"
export const ON_TOKEN_FAIL = "ON_TOKEN_FAIL";
export const ON_ACCESS_TOKEN_STATUS = "ON_ACCESS_TOKEN_STATUS";
export const ON_DOCUMENT_STORAGE_MODE = "ON_DOCUMENT_STORAGE_MODE";
export const ON_FILE_ACCESS_STATUS = "ON_FILE_ACCESS_STATUS";
export const ON_ACCORDION_EXPANDED_CHANGE = "ON_ACCORDION_EXPANDED_CHANGE";

/******************** Login Store **********************/
export const ON_LOGIN_REFRESH_PREACTION = "ON_LOGIN_REFRESH_PREACTION";

/******************* Login  Store **********************/

/******************** MetaData Store **********************/
export const ON_SUCCESS_MESSAGE_INVOKE = "ON_SUCCESS_MESSAGE_INVOKE";
export const ON_SUCCESS_MESSAGE_CLOSE = "ON_SUCCESS_MESSAGE_CLOSE";
export const ON_ERROR_MESSAGE_INVOKE = "ON_ERROR_MESSAGE_INVOKE";
export const ON_SERVER_ERROR_MESSAGE_INVOKE = "ON_SERVER_ERROR_MESSAGE_INVOKE";
export const ON_EXCEPTION_MESSAGE_INVOKE = "ON_EXCEPTION_MESSAGE_INVOKE";
export const ON_WARNING_MESSAGE_INVOKE = "ON_WARNING_MESSAGE_INVOKE";
export const ON_LOGIN_REFRESH_PREACTION_INVOKE = "ON_LOGIN_REFRESH_PREACTION_INVOKE";

/******************* MetaData  Store **********************/


/***************Check-in Document Store **********************/
export const ON_CHECKIN_EXISTING_STATUS_CHANGE = "ON_CHECKIN_EXISTING_STATUS_CHANGE";
export const ON_CHECKIN_EXISTING_DATA_CHANGE = "ON_CHECKIN_EXISTING_DATA_CHANGE";
export const ON_CHECKIN_NEW_REVISION_STATUS_CHANGE = "ON_CHECKIN_NEW_REVISION_STATUS_CHANGE";
/***************OneDrive Document Store **********************/


/***************OneDrive Document Store **********************/
export const ON_SELECTED_ONEDRIVE_FILE_CHANGE = "ON_SELECTED_ONEDRIVE_FILE_CHANGE";
/***************OneDrive Document Store **********************/

/***************Working Document Store **********************/
export const ON_WORKING_DOCUMENT_LIST_LOAD_STATUS = "ON_WORKING_DOCUMENT_LIST_LOAD_STATUS";
export const ON_WORKING_DOCUMENT_MODEL_OPEN = "ON_WORKING_DOCUMENT_MODEL_OPEN";
export const ON_WORKING_DOCUMENT_LOAD_STATUS = "ON_WORKING_DOCUMENT_LOAD_STATUS";
export const ON_WORKING_DOCUMENT_LIST = "ON_WORKING_DOCUMENT_LIST";
export const ON_WORKING_IFS_DOCUMENT_CHANGE = "ON_WORKING_IFS_DOCUMENT_CHANGE";
export const ON_WORKING_DOCUMENT_CHANGE = "ON_WORKING_DOCUMENT_CHANGE";
export const ON_WORKING_DOCUMENT_CHECKIN_TYPE_CHANGE = "ON_WORKING_DOCUMENT_CHECKIN_TYPE_CHANGE";
/***************End of Working Document Store **********************/

/***************All Document Store **********************/
export const ON_IFS_DOCUMENT_DETAILS_LOAD_STATUS = "ON_IFS_DOCUMENT_DETAILS_LOAD_STATUS";
export const ON_IFS_DOCUMENT_DETAILS_MODEL_OPEN = "ON_IFS_DOCUMENT_DETAILS_MODEL_OPEN";
/***************End of All Document Store **********************/

/******************** Checkout Store **********************/
export const ON_CHECKOUT_DOCUMENT_CHANGE = "ON_CHECKOUT_DOCUMENT_CHANGE";
export const ON_CHECKOUT_DOCUMENT_STATUS_CHANGE = "ON_CHECKOUT_DOCUMENT_STATUS_CHANGE";

/******************* Checkout  Store **********************/

/***************Channel Store **********************/
export const ON_CHANNEL_CONFIG_LOAD = "ON_CHANNEL_CONFIG_LOAD";
export const ON_CHANNEL_OBJECT_CHANGE = "ON_CHANNEL_OBJECT_CHANGE";
export const ON_CHANNEL_DESCRIPTION_UPDATE = "ON_CHANNEL_DESCRIPTION_UPDATE";
export const ON_IS_PRIMARY_CHANNEL = "ON_IS_PRIMARY_CHANNEL";
/***************Channel Store **********************/

/***************Toast Store **********************/
export const ON_DELETE_ONEDRIVE_SUCCESS = 'ON_DELETE_ONEDRIVE_SUCCESS';
export const ON_DELETE_ONEDRIVE_ERROR = 'ON_DELETE_ONEDRIVE_ERROR';
export const ON_CHECKIN_EXISTING_SUCCESS = 'ON_CHECKIN_EXISTING_SUCCESS';
export const ON_CHECKIN_EXISTING_ERROR = 'ON_CHECKIN_EXISTING_ERROR';
export const ON_CHECKIN_EXISTING_WARNING = 'ON_CHECKIN_EXISTING_WARNING';
/***************Toast Store **********************/